export type SituationType = 'MARRIED' | 'SINGLE' | 'WIDOWER' | 'OTHER';

export type SituationTypeEnum = {
  [key in SituationType]: key
};

export const situationTypeEnum: SituationTypeEnum = {
  MARRIED: 'MARRIED',
  SINGLE: 'SINGLE',
  WIDOWER: 'WIDOWER',
  OTHER: 'OTHER',
};
